module.exports = __webpack_public_path__ + "img/linkedin-icon.8f621413.svg";